import { CompetitionList } from '~/apis/ssf';
import { match, P } from 'ts-pattern';
import { Badge } from '~/components/Badge/Badge';

interface Props {
  competition: Pick<CompetitionList, 'state' | 'registration_open' | 'registrations_limit' | 'registrations_count'>;
}

export function CompetitionBadge({ competition }: Props) {
  return match(competition)
    .with({ state: 'PUBLISHED', registration_open: false }, () => <Badge variant="danger" label="Anmälan stängd" />)
    .with(
      {
        state: 'PUBLISHED',
        registration_open: true,
        registrations_limit: P.when((limit): limit is number => limit != null),
        registrations_count: P.when((count): count is number => count != null),
      },
      c =>
        c.registrations_count >= c.registrations_limit ? (
          <Badge variant="default" label="Anmälan full" />
        ) : (
          <Badge variant="success" label="Öppen för anmälan" />
        )
    )
    .with({ state: 'PUBLISHED', registration_open: true }, () => <Badge variant="success" label="Öppen för anmälan" />)
    .with({ state: 'CREATED' }, () => <Badge variant="default" label="Inte publicerad" />)
    .with({ state: 'ARCHIVED' }, () => <Badge variant="default" label="Arkiverad" />)
    .with({ state: 'CLOSED' }, () => <Badge variant="default" label="Stängd" />)
    .otherwise(() => competition.state);
}
